<div class="metrics-dashboard-card">
    <h5>{{title}}</h5>
    <div class="metrics-canvas-container">
      <canvas class="metrics-canvas" #chart></canvas>
    </div>
  </div>